@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.department.departments' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<button class="margin-left-8 margin-right-8" mat-flat-button [disabled]="!initialized" color="primary" (click)="toggleShowInactive()">
			{{ 'mes.administration.department.isActive.' + showInactive | translate }}
		</button>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	<table class="table-responsive outer-table" mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)" multiTemplateDataRows>
		<ng-container matColumnDef="name">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.department.departments' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.name }}</td>
		</ng-container>
		<ng-container matColumnDef="approver">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.department.shift-approver' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.approver }}</td>
		</ng-container>
		<ng-container matColumnDef="backup">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.department.shift-approver-extra' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.backup }}</td>
		</ng-container>
		<ng-container matColumnDef="isActive">
			<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.department.isActive.label' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<mat-icon svgIcon="{{ element.isActive ? 'acies_true' : 'acies_false' }}" [ngClass]="element.isActive ? 'greenColor' : 'redColor'"></mat-icon>
			</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th class="text-align-end" mat-header-cell *matHeaderCellDef>
				{{ 'general.actions' | translate }}
			</th>
			<td class="text-align-end" mat-cell *matCellDef="let row">
				<button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
					<mat-icon class="padding-top-5" mat-list-icon svgIcon="acies_overflow_menu"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item [disabled]="!initialized" (click)="openCreateEditUpdateDepartment(row.department)">
						<span>{{ 'mes.administration.department.actions.edit' | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>

		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let item" [attr.colspan]="displayedColumns.length">
				<div class="department-detail" [@detailExpand]="expandedElements.includes(item) ? 'expanded' : 'collapsed'">
					@if (item.department.employees?.data?.length > 0) {
						<table class="employees-list" mat-table [dataSource]="item.department.employees.data" matSort (matSortChange)="onInnerSort($event, item.department)">
							<ng-container matColumnDef="alias">
								<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
									{{ 'mes.administration.department.employee' | translate }}
								</th>
								<td mat-cell *matCellDef="let employee">
									({{ employee.alias }}) {{ employee.firstName }}
									{{ employee.lastName }}
								</td>
							</ng-container>
							<ng-container matColumnDef="teamProfileId">
								<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
									{{ 'mes.administration.department.team-profile' | translate }}
								</th>
								<td mat-cell *matCellDef="let employee">
									@if (getTeamProfile(employee.teamProfileId); as teamProfile) {
										({{ teamProfile.alias }}) {{ teamProfile.description }}
									}
								</td>
							</ng-container>
							<ng-container matColumnDef="extendedActions">
								<th class="text-align-end" mat-header-cell *matHeaderCellDef>
									{{ 'general.actions' | translate }}
								</th>
								<td class="text-align-end" mat-cell *matCellDef="let row">
									<button mat-icon-button [matMenuTriggerFor]="menu">
										<mat-icon class="padding-top-5" mat-list-icon svgIcon="acies_overflow_menu"></mat-icon>
									</button>
									<mat-menu #menu="matMenu">
										<button mat-menu-item [disabled]="!initialized" (click)="onEditEmployeeClick(row)">
											<span>
												{{ 'mes.administration.department.general.edit' | translate }}
											</span>
										</button>
									</mat-menu>
								</td>
							</ng-container>
							<tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
							<tr class="inner-data-row" mat-row *matRowDef="let employee; columns: innerDisplayedColumns"></tr>
						</table>
					}
				</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr class="department-row" mat-row *matRowDef="let item; columns: displayedColumns" [class.department-expandable]="item.department.employees.data?.length" [class.employee-expanded-row]="expandedElements.includes(item)" (click)="toggleRow(item)"></tr>
		<tr class="department-detail-row" mat-row *matRowDef="let row; columns: ['expandedDetail']"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
